import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 자리 예약 관리 페이지.
 * 원본 전체 구현은 SeatReservationManagement.full.tsx 에 있으며,
 * 현재는 임시 단순 버전 사용 중.
 */
const SeatReservationManagement: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginBottom: 16 }}>학급 자리 예약</h1>
      <p style={{ marginBottom: 16 }}>
        <button
          type="button"
          onClick={() => navigate('/class/teacher/ClassManagementHome')}
          style={{ padding: '8px 16px', cursor: 'pointer' }}
        >
          학급 홈으로
        </button>
      </p>
      <p style={{ color: '#666', fontSize: 14 }}>
        전체 기능은 SeatReservationManagement.full.tsx 기반으로 다시 이전한 뒤 복구하여 사용할 수 있습니다.
      </p>
    </div>
  );
};

export default SeatReservationManagement;
